import { themes } from '../themes/formThemes';

export const useFormTheme = (themeName = 'default') => {
  return themes[themeName] || themes.default;
};